import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './ConectarInstagramPublic.css';
import Loading from '../components/Loading';

const ConectarInstagramDirectPublic = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [influencerData, setInfluencerData] = useState(null);

  console.log('🎯 ConectarInstagramDirectPublic renderizado. Token:', token);

  useEffect(() => {
    const validateToken = async () => {
      try {
        console.log('🔍 Validando token Instagram Direct:', token);

        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/content';
        const validationUrl = `${apiUrl}/public/validate-instagram-direct-token/${token}/`;

        console.log('🌐 URL de validación:', validationUrl);

        const response = await axios.get(validationUrl);

        console.log('✅ Respuesta de validación:', response.data);

        if (response.data.success) {
          setInfluencerData(response.data);
        } else {
          setError(response.data.error);
        }
      } catch (err) {
        console.error('❌ Error al validar token:', err);
        console.error('❌ Response:', err.response);
        const errorMsg = err.response?.data?.error || 'Error al validar el link. Por favor, solicita uno nuevo.';
        setError(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      validateToken();
    } else {
      setError('Token no proporcionado en la URL');
      setLoading(false);
    }
  }, [token]);

  const handleConnectInstagram = () => {
    if (!influencerData) return;

    // Obtener el host base SIN /api/content
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    console.log('📍 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    console.log('📍 apiUrl (con fallback):', apiUrl);

    const backendUrl = apiUrl.replace(/\/api(\/content)?\/?$/, '');
    console.log('📍 backendUrl (después del replace):', backendUrl);

    const connectUrl = `${backendUrl}/instagram/connect-influencer-direct/${influencerData.influencer_id}/`;
    console.log('🔗 URL completa de conexión:', connectUrl);
    console.log('📷 Redirigiendo a Instagram Direct Login...');

    // Redirigir directamente al flujo de Instagram Direct Login
    window.location.href = connectUrl;
  };

  if (loading) {
    return (
      <div className="public-connect-container">
        <div className="public-connect-card">
          <Loading fullScreen={false} mensaje="Verificando link" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-connect-container">
        <div className="public-connect-card error-card">
          <div className="error-icon">❌</div>
          <h2>Link Inválido o Expirado</h2>
          <p className="error-message">{error}</p>
          <p className="error-help">
            Por favor, contacta al administrador para obtener un nuevo link de conexión.
          </p>
        </div>
      </div>
    );
  }

  if (!influencerData) {
    return null;
  }

  if (influencerData.instagram_connected) {
    return (
      <div className="public-connect-container">
        <div className="public-connect-card success-card">
          <div className="success-icon">✅</div>
          <h2>Cuenta Ya Conectada</h2>
          <div className="influencer-info">
            {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
              <img
                src={influencerData.influencer_profile_image_url}
                alt={influencerData.influencer_name || 'Influencer'}
                className="influencer-avatar-large"
              />
            )}
            <h3>{influencerData.influencer_name || 'Influencer'}</h3>
            <p className="instagram-username">@{influencerData.influencer_username || 'username'}</p>
          </div>
          <p className="success-message">
            Tu cuenta de Instagram <strong>@{influencerData.instagram_username || 'tu cuenta'}</strong> ya está conectada.
          </p>
          <p className="success-help">
            Puedes cerrar esta ventana. El administrador puede publicar contenido en tu cuenta de forma automática.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="public-connect-container">
      <div className="public-connect-card">
        {/* Header */}
        <div className="public-header">
          <div className="header-icon-large">📷</div>
          <h1>Conecta tu Instagram con Login Directo</h1>
          <span className="badge-direct">Instagram Direct API</span>
        </div>

        {/* Influencer Info */}
        <div className="influencer-info">
          {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
            <img
              src={influencerData.influencer_profile_image_url}
              alt={influencerData.influencer_name || 'Influencer'}
              className="influencer-avatar-large"
            />
          )}
          <h2>Hola, {influencerData.influencer_name || 'Influencer'}</h2>
          <p className="instagram-username">@{influencerData.influencer_username || 'username'}</p>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <p className="info-text">
            Conecta tu cuenta de Instagram de forma directa para que podamos publicar
            contenido automáticamente en tu nombre.
          </p>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🔒</span>
              <span className="feature-text">Seguro y privado</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span className="feature-text">Sin necesidad de Facebook Page</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔄</span>
              <span className="feature-text">Puedes revocar en cualquier momento</span>
            </div>
          </div>
        </div>

        {/* Connect Button */}
        <button
          onClick={handleConnectInstagram}
          className="btn-connect-instagram-direct"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path fill="#fff" d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z M17.5 6.5h.01" />
          </svg>
          Conectar con Instagram
        </button>

        {/* Requirements */}
        <div className="requirements-section requirements-direct">
          <h4>✨ Ventajas de Instagram Direct:</h4>
          <ul className="requirements-list">
            <li><strong>✅ Más simple:</strong> No requiere Facebook Page</li>
            <li><strong>✅ Cualquier cuenta:</strong> Business, Creator o Personal</li>
            <li><strong>✅ Menos pasos:</strong> Conexión directa con Instagram</li>
          </ul>
          <p className="note-text">
            <strong>Nota:</strong> Los insights (métricas) pueden ser más limitados que con Facebook Login.
          </p>
        </div>

        {/* Footer */}
        <div className="public-footer">
          <p className="footer-text">
            Al conectar tu cuenta, autorizas a la plataforma para publicar contenido
            previamente aprobado en tu cuenta de Instagram.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConectarInstagramDirectPublic;
